import { PageModel, PageStatus } from "../../../shared/model/page-model";
import { updatePageModelReducer } from "../../../shared/model/page-model-reduers";

export function updatePageModelForStatusChangeReducer(pageModel: PageModel, pageStatus: PageStatus): PageModel {
  let { title, informationMessages, buttonTitle, showButton } = pageModel;
  switch (pageStatus) {
    case "Ready":
      title = "Set New Password";
      informationMessages = [];
      buttonTitle = "Continue";
      showButton = true;
      break;
    case "Sending":
      title = "Please wait";
      informationMessages = ["Sending details to confirm account"];
      buttonTitle = "Sending";
      showButton = true;
      break;
    case "Succeeded":
      title = "Success";
      informationMessages = ["Your password has been updated."];
      buttonTitle = "";
      showButton = false;
      break;
    case "Failed":
      buttonTitle = "Retry";
      break;
    case "Missing Query Parameters":
      title = "Not Authorised";
      buttonTitle = "";
      informationMessages = ["Unable to determine client application."];
      showButton = false;
  }
  return updatePageModelReducer(pageModel, {
    title,
    informationMessages,
    buttonTitle,
    showButton
  });
}
